<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.form"
      @keydown.esc="dialog.form = false"
      :fullscreen="dialog.fullscreen"
      width="625"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          {{ form.id === '' ? 'Tambah' : 'Ubah' }}

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.form = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">
          <ValidationObserver 
            ref="form">
            <v-form>
              <ValidationProvider
                name="parent_id" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Unit Diatasnya
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-autocomplete
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  placeholder="Contoh. Fasilitas Pelayanan Kesehatan"

                  :search-input.sync="autocomplete.parent"
                  :loading="process.parent"
                  
                  :items="list_parent"
                  item-value="id"
                  item-text="name"
                  :item-color="set_color"

                  v-model="form.parent_id"
                  :success="form.parent_id !== '' && valid"
                  :error-messages="errors"
                  required
                  class="mb-6"
                  style="border-radius: 10px; width: 70%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Unit {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.parent_id !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-autocomplete>
              </ValidationProvider>

              <ValidationProvider 
                name="name" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Nama Unit
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  placeholder="Contoh. Finance"

                  v-model="form.name"
                  :success="form.name !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px; width: 70%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nama {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.name !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="code" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Kode
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  min="0"
                  
                  placeholder="Contoh. 001"

                  v-model="form.code"
                  :success="form.code !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px; width: 40%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Kode {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.code !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  class="py-0">
                  <div>
                    <div class="body-2 mb-2">
                      <!-- <span class="red--text">*</span> -->
                      Jam Presensi Datang
                      <span>
                        (boleh dikosongi)
                      </span>
                    </div>

                    <v-menu
                      ref="start_time"
                      v-model="time.start"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="form.absen_start_time"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <ValidationProvider 
                          name="Jam Presensi Datang" 
                          v-slot="{ errors, valid }">
                          <v-text-field
                            v-on:keyup.enter="save"
                            readonly
                            filled
                            rounded
                            dense
                            :color="set_color"
                            placeholder="Contoh. 09:00"

                            hide-details

                            clearable
                            @click:clear="form.absen_start_time = ''; form.absen_end_time = '';"
                            v-on="on"
                            v-bind="attrs"

                            v-model="form.absen_start_time"
                            :success="form.absen_start_time !== '' && form.absen_start_time !== null && valid"
                            :error-messages="errors"
                            class="mb-6"
                            style="border-radius: 10px;">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  Jam Presensi Datang {{ errors[0] }}
                                </v-tooltip>
                              </div>

                              <div v-if="form.absen_start_time !== '' && form.absen_start_time !== null && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </template>

                      <v-time-picker
                        v-if="time.start"
                        v-model="form.absen_start_time"
                        full-width
                        :color="set_color"
                        format="24hr"
                        @click:minute="$refs.start_time.save(`${form.absen_start_time}`); form.absen_end_time = '';">
                      </v-time-picker>
                    </v-menu>
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  class="py-0">
                  <div>
                    <div class="body-2 mb-2">
                      <!-- <span class="red--text">*</span> -->
                      Jam Presensi Pulang
                      <span>
                        (boleh dikosongi)
                      </span>
                    </div>
                    
                    <v-menu
                      ref="end_time"
                      v-model="time.end"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="form.absen_end_time"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <ValidationProvider 
                          name="Jam Presensi Pulang" 
                          v-slot="{ errors, valid }">
                          <v-text-field
                            v-on:keyup.enter="save"
                            readonly
                            filled
                            rounded
                            dense
                            :color="set_color"
                            placeholder="Contoh. 17:00"
                            
                            hide-details

                            clearable
                            @click:clear="form.absen_end_time = ''"
                            v-on="on"
                            v-bind="attrs"

                            v-model="form.absen_end_time"
                            :success="form.absen_end_time !== '' && form.absen_end_time !== null && valid"
                            :error-messages="errors"
                            class="mb-6"
                            style="border-radius: 10px;">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  Jam Presensi Pulang {{ errors[0] }}
                                </v-tooltip>
                              </div>

                              <div v-if="form.absen_end_time !== '' && form.absen_end_time !== null && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </template>

                      <v-time-picker
                        v-if="time.end"
                        :min="form.absen_start_time"
                        v-model="form.absen_end_time"
                        full-width
                        :color="set_color"
                        format="24hr"
                        @click:minute="$refs.end_time.save(`${form.absen_end_time}`)">
                      </v-time-picker>
                    </v-menu>
                  </div>
                </v-col>
              </v-row>

              <div
                class="mb-6">
                <div class="body-2 mb-2">
                  Silahkan geser marker untuk menentukan koordinat lokasi dibawah ini:
                </div>

                <gmap-map
                  :center="center"
                  :zoom="12"
                  :options="{
                    zoomControl: true,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: true,
                    disableDefaultUi: false
                  }"
                  :clickable="true"
                  @click="updatePlace"
                  style="width: 100%; height: 300px;">

                  <gmap-marker
                    :position="center"
                    :draggable="true"
                    @drag="updatePlace"
                    @click="center=center">
                  </gmap-marker>
                </gmap-map>
              </div>

              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  class="py-0">
                  <ValidationProvider 
                    name="latitude" 
                    v-slot="{ valid }">
                    <div class="body-2 mb-2">
                      Latitude
                      <span>
                        (boleh dikosongi)
                      </span>
                    </div>

                    <v-text-field
                      filled
                      rounded
                      dense
                      disabled
                      :color="set_color"
                      hide-details
                      type="number"
                      placeholder="Contoh. -7.689743"

                      v-model="form.latitude"
                      :success="form.latitude !== '' && valid"
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="form.latitude !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  class="py-0">
                  <ValidationProvider 
                    name="longitude" 
                    v-slot="{ valid }">
                    <div class="body-2 mb-2">
                      Longitude
                      <span>
                        (boleh dikosongi)
                      </span>
                    </div>

                    <v-text-field
                      filled
                      rounded
                      dense
                      disabled
                      :color="set_color"
                      hide-details
                      type="number"
                      placeholder="Contoh. 110.606819"

                      v-model="form.longitude"
                      :success="form.longitude !== '' && valid"
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="form.longitude !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <ValidationProvider 
                name="attended_range" 
                v-slot="{ valid }">
                <div class="body-2 mb-2">
                  Range
                  <span>
                    (boleh dikosongi)
                  </span>
                </div>

                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  placeholder="Contoh. 50"

                  v-model="form.attended_range"
                  :success="form.attended_range !== '' && valid"
                  class="mb-6"
                  style="border-radius: 10px; width: 40%;">
                  <template v-slot:append-outer>
                    <div v-if="form.attended_range !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-form>
          </ValidationObserver>

          <div v-if="message.error.length > 0"
            class="text-center my-4">
            <div
              class="error--text d-flex align-start">
              <v-icon size="18" color="red" class="mt-1">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.form = false; reset();">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete"
      @keydown.esc="dialog.delete = false"
      :fullscreen="dialog.fullscreen"
      width="500"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Hapus Data

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="body-1 font-weight-light text-first mt-3">
          Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.delete"
            :loading="process.delete"
            @click="deletes()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Hapus
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.delete"
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.map"
      @keydown.esc="dialog.map = false"
      :fullscreen="dialog.fullscreen"
      width="1000"
      persistent
      scrollable>
      <v-card v-if="markers.length > 0"
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title 
          class="d-flex align-center py-0 px-3 text-right popup-header">
          {{ markers[0].name }}

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.map = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">
          <gmap-map
            ref="gmap"
            :center="center"
            :zoom="12"
            :scrollwheel="false"
            style="width:100%;"
            :style="!dialog.fullscreen ? 'height: calc(100vh - 300px);' : 'height: calc(100vh - 100px);'">

            <gmap-marker
              v-for="(item, index) in markers"
              :key="index"
              :position="item.latlng"
              :icon="item.icon">
            </gmap-marker>
          </gmap-map>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col 
        cols="12"
        class="py-0">
        <v-card 
          flat 
          style="border: 1px solid #E0E0E0;">
          <v-card-text>
            <v-row>
              <v-col 
                cols="12" 
                md="8" 
                class="d-flex align-center">
                <div class="mr-3">
                  <v-btn
                    elevation="0"
                    style="background: #4caf5033; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center green--text"
                    @click="dialog.form = true; reset();">
                    <v-icon size="18">mdi-plus-circle-outline</v-icon>

                    <span class="ml-1">
                      Tambah
                    </span>
                  </v-btn>
                </div>

                <div v-if="selected.row.length === 1"
                  class="mr-3" >
                  <v-btn 
                    elevation="0"
                    style="background: #2196f333; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center blue--text"
                    @click="dialog.form = true; reset(selected.row[0]);">
                    <v-icon size="18">mdi-circle-edit-outline</v-icon>

                    <span class="ml-1">
                      Ubah
                    </span>
                  </v-btn>
                </div>

                <div v-if="selected.row.length > 0"
                  class="mr-3" >
                  <v-btn
                    elevation="0"
                    style="background: #f4403433; border-radius: 10px;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center red--text"
                    @click="toDelete()">
                    <v-icon size="18">mdi-delete-circle-outline</v-icon>

                    <span class="ml-1">
                      Hapus
                    </span>
                  </v-btn>
                </div>

                <div v-if="selected.row.length === 1"
                  class="mr-3" >
                  <v-btn
                    elevation="0"
                    style="border-radius: 10px;"
                    :style="`background: ${set_color_rgb}; color: ${set_color};`"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center"
                    @click="toMap()">
                    <v-icon size="18">mdi-map-marker-circle</v-icon>

                    <span class="ml-1">
                      Map
                    </span>
                  </v-btn>
                </div>
              </v-col>
                
              <v-col 
                cols="12" 
                md="4" 
                class="d-flex align-center justify-end">
                <v-text-field
                  filled
                  rounded
                  dense
                  single-line
                  hide-details
                  :color="set_color"
                  placeholder="Cari . . ."
                  vvvv-uppercase
                  append-icon="mdi-magnify"
                  clearable
                  v-model="search"
                  @click:clear="search = ''; fetch();"
                  v-on:keyup.enter="fetch()"
                  style="border-radius: 10px;">
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>

          <v-data-table
            v-model="selected.row"
            ref="table-grid"
            class="table-grid"
            :height="`calc(100vh - ${pagination.total_data > 0 ? '274px' : '202px'})`"
            :show-select="checkbox"
            :single-select="true"
            :loading="process.load"
            loading-text="Sedang memuat data . . ."
            loader-height="5"
            no-results-text="Belum ada data"
            :options.sync="options"
            :headers="configHeaders"
            :items="list"
            :items-per-page="100"
            item-key="id"
            @click:row="rowClick"
            @toggle-select-all="handleToggleAll($event)"
            @dblclick:row="doubleClick"
            hide-default-footer>
            <template
              v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
              v-slot:[`item.${header.value}`]="{ value }">
              {{ rowFormat(header.format, value) }} 
            </template>

            <template v-slot:[`item.index`]="{ index }">
              {{ lastIndex + index }}
            </template>

            <v-progress-linear 
              v-show="process.load" 
              slot="progress" 
              color="white" 
              indeterminate>
            </v-progress-linear>
          </v-data-table>

          <pagination v-if="pagination.total_data > 0"
            @changePage="fetch($event)" 
            @reloadPage="fetch($event)" 
            :model="pagination"/>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,
        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,
          form: false,
          delete: false,

          map: false
        },
        search: '',
        selected: {
          row: [],
          freeze: [],
          delete: []
        },
        options: {},
        headers: [],
        list: [],
        list_parent: [],
        pagination: {},
        lastIndex: 0,
        limit: 20,

        center: {
          lat: -7.8032076, 
          lng: 110.3573354
        },
        markers: [],
        
        autocomplete: {
          parent: ''
        },

        form: {
          id: '',
          parent_id: '',
          code: '',
          name: '',
          latitude: '',
          longitude: '',
          attended_range: '',

          absen_start_time: '',
          absen_end_time: ''
        },
        time: {
          start: false,
          end: false
        },
        process: {
          load: false,
          form: false,
          delete: false,

          parent: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      }
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          this.fetch(pagination)
        },
        deep: true
      },

      'autocomplete.parent': function() {
        this.fetchParent()
      }
    },
    mounted () {
      // this.fetch()
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value.split('.')[0]
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          },00`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].title)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
          // data = value.length > 0 ? moment(value).format(format === 'date' ? 'D MMM, YYYY' : format === 'time' ? 'HH:mm' : 'D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }
        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },
      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search
        }

        this.selected.row = []

        await get('admin/unit', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.headers = [
              {
                text: '#No',
                width: '75px',
                value: 'index',
                sortable: false,
                freeze: true,
                hide: false,
                align: 'center'
              },
              {
                text: 'Kode',
                width: '150px',
                value: 'code',
                freeze: false,
                hide: false
              },
              {
                text: 'Nama',
                width: '400px',
                value: 'name',
                freeze: false,
                hide: false
              },
              {
                text: 'Jam Presensi Datang',
                width: '200px',
                value: 'absen_start_time',
                freeze: false,
                hide: false
              },
              {
                text: 'Jam Presensi Pulang',
                width: '200px',
                value: 'absen_end_time',
                freeze: false,
                hide: false
              },
              {
                text: 'Latitude',
                width: '200px',
                value: 'latitude',
                freeze: false,
                hide: false
              },
              {
                text: 'Longitude',
                width: '200px',
                value: 'longitude',
                freeze: false,
                hide: false
              },
              {
                text: 'Range',
                width: '150px',
                value: 'attended_range',
                freeze: false,
                hide: false
              },
              {
                text: 'Total Pegawai',
                width: '150px',
                value: 'total_pegawai',
                freeze: false,
                hide: false
              },
              {
                text: 'Unit Diatasnya',
                width: '120px',
                value: 'parent_id',
                freeze: false,
                hide: false,
                align: 'center'
              }
            ]
            
            this.list = res.results.data
            this.pagination = res.results.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },
      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: ${this.set_color};
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: ${this.set_color};
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      async fetchParent () {
        this.process.parent = true

        let params = {
          limit: 100000,
          search: this.autocomplete.parent
        }

        // this.list_parent = [
        //   {
        //     id: 0,
        //     name: 'Semua'
        //   }
        // ]

        await get('admin/unit', { params })
        .then(response => {
          let res = response.data

          this.process.parent = false
            
          if (res.status === 200) {
            let data = res.results.data

            this.list_parent = [
              {
                id: '0',
                name: 'Semua'
              }
            ]
            
            data.map(obj => {
              this.list_parent.push({
                id: obj.id,
                name: obj.name
              })
            })
          }
        })
      },
      
      reset (item) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: item !== undefined ? item.id : '',
          parent_id: item !== undefined ? item.parent_id : '',
          code: item !== undefined ? item.code : '',
          name: item !== undefined ? item.name : '',
          latitude: item !== undefined ? parseFloat(item.latitude) : this.center.lat,
          longitude: item !== undefined ? parseFloat(item.longitude) : this.center.lng,
          attended_range: item !== undefined ? item.attended_range : '',

          absen_start_time: item !== undefined ? item.absen_start_time : '',
          absen_end_time: item !== undefined ? item.absen_end_time : ''
        }

        this.time = {
          start: false,
          end: false
        }

        this.process.form = false

        this.message.error = ''

        if (this.dialog.form) this.fetchParent()
        
        this.getGeoLocation()
      },
      getGeoLocation() {
        if (this.form.id === '') {
          navigator.geolocation.getCurrentPosition(position => {
            this.center = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
          })
        } else {
          this.center = {
            lat: this.form.latitude,
            lng: this.form.longitude
          }
        }
      },
      updatePlace(location) {
        this.center = {
          lat: location.latLng.lat(),
          lng: location.latLng.lng()
        }

        this.form.latitude = location.latLng.lat()
        this.form.longitude = location.latLng.lng()
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.id.length < 1 ? 'admin/unit/add' : 'admin/unit/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.reset()

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      toDelete () {
        this.selected.delete = []

        for (let i in this.selected.row) {
          this.selected.delete.push(parseInt(this.selected.row[i].id))
        }

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post('admin/unit/delete', {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          if (res.status === 200) {
            this.process.delete = false
            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.process.delete = false
            this.message.error = res.message
          }
        })
      },

      // MAP
      toMap () {
        this.markers = []

        this.dialog.map = true

        this.$gmapApiPromiseLazy().then(() => {
          this.markers.push({
            id: this.selected.row[0].id,
            code: this.selected.row[0].code,
            name: this.selected.row[0].name,
            latlng: {
              lat: parseFloat(this.selected.row[0].latitude), 
              lng: parseFloat(this.selected.row[0].longitude)
            },
            icon: {
              url: require('@/assets/image/location_pin.png'),
              scaledSize: new google.maps.Size(50, 50),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(10, 10)
            }
          })

          this.center = this.markers.length > 0 ? this.markers[0].latlng : this.center
        })
      }
    }
  }
</script>

<style>
  .table-grid table thead > tr > th, .table-grid table tbody > tr > td {
    position: sticky;
    position: -webkit-sticky;
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }

  .table-grid table > tbody > tr > td:nth-child(1) {
    left: 0; 
    z-index: 1;
  }

  .table-grid table > tbody > tr:nth-of-type(even) .text-start, table > tbody > tr:nth-of-type(even) .text-center, table > tbody > tr:nth-of-type(even) .text-end {
    background: #fafafa;
  }

  .table-grid table > tbody > tr:nth-of-type(odd) .text-start, table > tbody > tr:nth-of-type(odd) .text-center, table > tbody > tr:nth-of-type(odd) .text-end {
    background: white;
  }
</style>